export const Colors = {
  error: '#FF0000',
  text: '#ECE4F5',
  black: '#000',
  blackOpacity80: 'rgba(0, 0, 0, 0.8)',
  blackOpacity05: 'rgba(0, 0, 0, 0.5)',
  green0: '#06AF21',
  purple0: '#200A3E',
  purple0opacity10: 'rgba(32, 10, 62, 0.1)',
  purple0opacity50: '#200A3E80',
  purple0opacity85: '#200A3EDA',
  purpleElevation1: '#2A1250', // Lightest elevation
  purpleElevation2: '#331658', // Light elevation
  purpleElevation3: '#3D1A60', // Medium elevation
  purpleElevation4: '#421D68', // Higher elevation (clock face)
  purpleElevation5: '#4A2070', // Highest elevation
  purple1: '#DA20D1',
  purple1opacity50: '#DA20D180',
  purple1opacity80: '#DA20D1DA',
  pink0: '#FF1493',
  pink0opacity50: '#FF149380',
  orange0: '#FF4500',
  tint: '#fff',
  opacity025: 'rgba(255, 255, 255, 0.025)',
  opacity03: 'rgba(255, 255, 255, 0.03)',
  opacity05: 'rgba(255, 255, 255, 0.05)',
  opacity10: 'rgba(255, 255, 255, 0.1)',
  opacity20: 'rgba(255, 255, 255, 0.2)',
  opacity40: 'rgba(255, 255, 255, 0.4)',
  opacity50: 'rgba(255, 255, 255, 0.5)',
  tabIconDefault: '#fff',
  yellow0: '#FFD700',
  yellow0opacity50: '#FFD70080',
  inputGrey: '#ECE4F51a',
  placeholderText: '#cac4d0',
  disabled: {
    iconTint: '#83788380',
    purple1opacity50: '#dbdbdb33',
    yellow0: '#DBDBDB',
    purple0: '#DBDBDB0f',
  },
};
